import { AllInvoiceIdsRequest } from '../../../domain/invoicing/invoicingApi'
import { toEmailFilter } from '../emailFilter'
import { AllInvoicesFilterValues } from './AllInvoicesFilters'

export const toIdsRequest = (filters: AllInvoicesFilterValues): AllInvoiceIdsRequest => {
  return {
    paidStatus: filters.paidStatus,
    search: filters.search || undefined,
    customerId: filters.customerId,
    jobType: filters.jobType,
    divisionId: filters.divisionId,
    qboStatus: filters.qboStatus,
    creationDateStart: filters.creationDateStart,
    creationDateEnd: filters.creationDateEnd,
    dueDateStart: filters.dueDateStart,
    dueDateEnd: filters.dueDateEnd,
    emailFilter: toEmailFilter(filters.emailStatus),
  }
}
